export const DOCUMENTATION = 'documentation'
export const APPROVAL = 'approval'

export const ALL_PROCESSES = [DOCUMENTATION, APPROVAL] as const

export type Process = (typeof ALL_PROCESSES)[number]
